import { Controller } from "stimulus";
import { observeIntersection } from "../../util/observe_intersection"
import { getCSRFToken } from "../../util";

export default class extends Controller {
  static targets = [
    "votePanel",
    "voteResultPanel",
    "voteResult",
    "voteResultImage",
    "positiveBar",
    "positiveLabel",
    "negativeBar",
    "negativeLabel",
    "positiveVote",
    "negativeVote",
  ]

  connect() {
    fetch(`/sentiment_votes/voted_coin_today?api_symbol=${this.votePanelTarget.dataset.coinApiSymbol}`)
      .then(response => response.json())
      .then(voted => {
        this._toggleVotePanel(voted);
      });
  }

  _toggleVotePanel(voted) {
    if (voted && voted.id) {
      this.votePanelTarget.classList.add("tw-hidden");
      this.voteResultPanelTarget.classList.remove("tw-hidden");
      this.voteResultTarget.innerText = voted.sentiment_in_string;

      if (voted.sentiment === 1) {
        this.voteResultImageTarget.src = this.positiveVoteTarget.dataset.imagePath;
      } else {
        this.voteResultImageTarget.src = this.negativeVoteTarget.dataset.imagePath;
      }
    } else {
      this.votePanelTarget.classList.remove("tw-hidden");
      this.voteResultPanelTarget.classList.add("tw-hidden");
    }
  }

  votedFeedback(){
    this._createSentimentVoteEntry();

    event.currentTarget.parentElement.parentElement.classList.add("tw-hidden");
    this.voteResultPanelTarget.classList.remove("tw-hidden");
    this.voteResultImageTarget.src = event.currentTarget.dataset.imagePath;
    this.voteResultTarget.innerText = event.currentTarget.dataset.text;

    if (event.currentTarget.dataset.sentiment === "positive") {
      this.updatePositiveVoteWhenNull();
    } else if (event.currentTarget.dataset.sentiment === "negative") {
      this.updateNegativeVoteWhenNull();
    }
  }

  _createSentimentVoteEntry() {
    this.sentimentVotePath = event.currentTarget.dataset.path;
    fetch(this.sentimentVotePath, {
      method: "POST",
      headers: {
        "X-CSRF-Token": getCSRFToken(),
      },
      credentials: "same-origin",
    }).then(
      response => response.json()
    );
  }

  updatePositiveVoteWhenNull() {
    if (this.positiveBarTarget.style.width === "0%" && this.negativeBarTarget.style.width === "0%") {
      this.positiveBarTarget.style.width = "100%";
      this.positiveLabelTarget.innerText = "100%";
    }
  }

  updateNegativeVoteWhenNull() {
    if (this.positiveBarTarget.style.width === "0%" && this.negativeBarTarget.style.width === "0%") {
      this.negativeBarTarget.style.width = "100%";
      this.negativeLabelTarget.innerText = "100%";
    }
  }
}
